import { MantineSize } from '@mantine/core';
import ModalWrapper from './ModalWrapper';

export default ModalWrapper;

export interface ModalWrapperProps {
  children: React.ReactNode;
  isVisible: boolean;
  withCloseButton?: boolean;
  size?: MantineSize | (string & {}) | number;
  title?: string;
  onClose: () => void;
}
